// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"292":"af58e269","321":"ddb0ed0c","983":"930955fe"}[chunkId] + ".chunk.css";
};